module.exports = __webpack_public_path__ + "img/ngb.575176b0.jpg";